import { atom } from 'jotai'
import type { TCreditCard } from '../../types/TCreditCard'

export const creditCardState = atom<TCreditCard>({
    creditCardNumber: '',
    payer: '',
    expDate: '',
    cvv: ''
})
